import React, { PropsWithChildren } from 'react'
import { createStyles, withStyles } from '@mui/styles'
import { defaultColors, muiOptions, MuiProps } from '../../../infrastructure/materialUiThemeProvider'
import { WithTooltip } from './withTooltip'

export function _Link({ classes, tooltipText, onClick, className, children }: MuiProps & PropsWithChildren<Props>) {
    return (
        <WithTooltip text={tooltipText}>
            <span onClick={onClick ?? noop} className={classes.link + (className ? ' ' + className : '')}>
                {children}
            </span>
        </WithTooltip>
    )
}

type Props = {
    onClick?: () => void
    tooltipText?: string
    className?: string
}

const noop = () => { }

const styles = _ => createStyles({
    link: {
        color: defaultColors.lightBlue.light.color,
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            color: '#BCD6FE'
        }
    }
})

export let Link = withStyles(styles, muiOptions)(_Link)